<template>
  <!--v-scrollBar:tableArg
  v-contextmenu:contextmenu-->
  <div class="taskGroupList">
    <el-table
      :data="taskGroupCurrent"
      border
      ref="taskTable"
      v-loading="loading"
      element-loading-text="加载中,请稍候"
      element-loading-spinner="el-icon-loading"
      v-loadmore="load"
      @row-dblclick="rowDbclick"
      @current-change="handleCurrentChange"
      highlight-current-row
      @keyup.alt.67.native="copy()"
      tooltip-effect="dark"
      :height="tableHeight"
      @row-contextmenu="rowContextmenu"
      @select="select"
      @select-all="selectAll"
      @header-dragend="headerDragend"
    >
      <el-table-column
        type="selection"
        style="display:inline-block"
        v-if="isCheckbox||expand"
        :selectable="isDisabled"
        width="55"
      ></el-table-column>
      <el-table-column
        sortable
        label="状态"
        v-if="!isTemplate"
        prop="TASKSTATENAME"
        align="center"
        width="80"
        :cell-style="{'text-align':'center'}"
      >
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.TASKSTATENAME" placement="top" effect="light">
            <div style="margin-left: 21px;" :class="scope.row.STATE | taskStateFormater"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="TASKNAME"
        align="left"
        min-width="200"
        label="名称"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <!--<span>{{scope.row.TASKNAME }}</span>-->
          <el-popover
            v-show="isPopover(scope.row)"
            placement="top-start"
            width="400"
            trigger="hover"
          >
            <div>
              <el-row v-for="(item, index) in scope.row.MatchFields" :key="index">
                <el-col :span="5">{{ item.Name + ":" }}</el-col>
                <el-col :span="19" v-html="item.Value"></el-col>
              </el-row>
            </div>
            <div
              slot="reference"
              @click="taskSelected(scope.row)"
              style="cursor:pointer;display:flex;align-items:center"
            >
              <el-tooltip placement="top" effect="light">
                <div slot="content" v-html="scope.row.TASKTYPENAME"></div>
                <i :class="getTaskType(scope.row)"></i>
              </el-tooltip>
              <div
                class="taskName1"
                v-html="
                  Highlight(scope.row, '任务名',getTaskShowName(scope.row))
                "
              ></div>
              <div
                class="taskContent"
                v-html="
                  Highlight(
                    scope.row,
                    '任务详情',
                    ellipsis(delHtmlTag(scope.row.CONTENT),200)
                  )"
              ></div>
            </div>
          </el-popover>
          <div
            v-show="!isPopover(scope.row)"
            @click="taskSelected(scope.row)"
            style="cursor:pointer;display:flex;align-items:center"
          >
            <el-tooltip :content="scope.row.TASKTYPENAME" placement="top" effect="light">
              <i :class="getTaskType(scope.row)"></i>
            </el-tooltip>
            <div
              class="taskName1"
              v-html="
                Highlight(scope.row, '任务名', getTaskShowName(scope.row))"
            ></div>
            <div
              class="taskContent"
              v-html="
                Highlight(scope.row, '任务详情', ellipsis(delHtmlTag(scope.row.CONTENT),200))"
            ></div>
            <div class="tag" v-html="getTagName(scope.row)"></div>
          </div>
        </template>
      </el-table-column>
      <!--<el-table-column sortable prop="TASKSTATENAME"  width="120" label="执行状态" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.TASKSTATENAME }}</span>
        </template>
      </el-table-column>-->
      <!-- <el-table-column
        sortable
        prop="CREATETIME"
        label="任务标签"
        align="left"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="diplay:flex">
            <span
              class="tag-span"
              v-for="(tag, index) in scope.row.TagList"
              :key="index"
              v-html="getTagName(tag)"
            >
            </span>
          </span>
        </template>
      </el-table-column>-->
      <el-table-column
        sortable
        prop="CREATEUSERNAME"
        label="创建人"
        min-width="120"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{ createUserName(scope.row.CREATEUSERNAME) }}</template>
      </el-table-column>
      <el-table-column
        sortable
        prop="CREATETIME"
        label="创建时间"
        align="center"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.CREATETIME | timeFormater }}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="ACTUALOPERATETIME"
        label="最新操作时间"
        align="center"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.ACTUALOPERATETIME | timeFormater }}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="服务台"
        prop="SERVERCENTERID"
        align="center"
        show-overflow-tooltip
        min-width="200"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.SERVERCENTERNAME ? true : false"
            class="iconfont icon-diannao1"
            style="color:rgb(33,189,123)"
          ></i>
          {{ scope.row.SERVERCENTERNAME }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="EXCUTEUSERNAME"
        label="执行人"
        min-width="100"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ excuteUserName(scope.row.EXCUTEUSERNAME) }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="FOCUSDEGREE" align="center" label="关注度" min-width="100">
        <template slot-scope="scope">
          <!-- <div :class="scope.row.FOCUSDEGREE|focusDegreeFormater">
          </div>-->
          <el-rate v-model="scope.row.FOCUSDEGREE" @change="grade" :max="3"></el-rate>
        </template>
      </el-table-column>
    </el-table>
    <v-contextmenu ref="contextmenu">
      <!-- <v-contextmenu-item @click="copy()">复制</v-contextmenu-item>
      <v-contextmenu-item :disabled="copyitem?false:true" @click="paste()">粘贴</v-contextmenu-item>-->
      <!-- <v-contextmenu-item @click="save()">保存为模板</v-contextmenu-item> -->
      <v-contextmenu-item @click="open()">打开</v-contextmenu-item>
      <v-contextmenu-item @click="handleFolderMenuClick()">详情</v-contextmenu-item>
      <v-contextmenu-item @click="workRecordDetail()">工作记录</v-contextmenu-item>
    </v-contextmenu>
    <TaskDetails ref="taskDetail"></TaskDetails>
    <workRecordDialog ref="workRecordDialog"></workRecordDialog>
    <contextMenu ref="contextMenu" :contextMenu="contextmenuRow"></contextMenu>
    <CreateTask ref="CreateTask" :refreshType="0" @getValue="getList"></CreateTask>
    <!-- <createTemplate
      ref="createTemplate"
      :userId="userId"
      :body="true"
      @guanbi="guantc"
      :temType="0"
    ></createTemplate>-->
  </div>
</template>

<script>
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import TaskDetails from "../components/TaskDetails.vue";
import workRecordDialog from "../taskGroup/workRecordDialog.vue";
import CreateTask from "../common/CreateTask.vue";
import createTemplate from "@/components/MainLayout/template/createTemplate.vue";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { GetSubTaskTreePathByTaskId } from "@/api/modules/basicData/basicTask";
import { AllChildNode } from "@/api/modules/basicData/commonData";
import { UpdateTaskMemberFocusDegree } from "@/api/modules/basicData/task";
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import { FormatHtml } from "@/util/common";
var time = null; //  在这里定义time 为null
export default {
  name: "taskFolderList",
  components: {
    TaskDetails: () => import("../components/TaskDetails.vue"),
    createTemplate,
    workRecordDialog,
    contextMenu: () => import("@/views/task/common/contextmenu.vue"),
    CreateTask: () => import("../common/CreateTask.vue"),
  },
  props: {
    tableHeight: {
      type: [String, Number],
      default: function () {
        return $(window).height() - 245;
      },
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    isTemplate: {
      //是否是模板
      type: Boolean,
      default: false,
    },
    isShowButton: {
      //是否显示按钮，不显示按钮不需要触发dispatch("changeCurTask"）
      type: Boolean,
      default: true,
    },
    isStore: {
      //是否用store方式显示数据
      type: Boolean,
      default: true,
    },
    tableData: {
      //表数据
      type: Array,
      default: () => {
        return [];
      },
    },
    expand: {
      //是否显示多选框
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskGroupCurrent: [],
      contextmenuRow: {},
      num: null,
      taskIds: [],
      newRow: {}, // 当前任务
      copyitem: null,
      taskInfo: {},
      TaskType: JSON.parse(localStorage.getItem("TaskType")),
      columns: [
        // 列
        {
          text: "任务",
          value: "INSTANCE",
        },
        {
          text: "任务类型",
          value: "TASKTYPENAME",
          width: 200,
        },
        {
          text: "执行状态",
          value: "TASKSTATENAME",
        },
        {
          text: "任务名称",
          value: "TASKNAME",
        },
        {
          text: "创建人",
          value: "CREATEUSERNAME",
        },
        {
          text: "创建时间",
          value: "CREATETIME",
        },
        {
          text: "执行人",
          value: "EXCUTEUSERNAME",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.task.userId,
      ServerCenterIds: (state) => state.task.ServerCenterIds,
      createIdentity: (state) => state.task.createIdentity,
      contactId: (state) => state.user.ContactID,
      realName: (state) => state.task.realName,
      departmentId: (state) => state.user.departmentId,
      departmentName: (state) => state.user.departmentName,
      companyId: (state) => state.user.companyId,
      companyName: (state) => state.user.companyName,
      GroupCurrent: (state) => state.task.taskGroupCurrent,
      taskGroupList: (state) => state.task.taskGroupList,
      copyInfo: (state) => state.folder.copyInfo,
      taskSource: (state) => state.task.taskSource,
      isCheckbox: (state) => state.task.isCheckbox,
      loading: (state) => state.task.loading,
      isInfiniteScroll: (state) => state.task.isInfiniteScroll,
      totalCount: (state) => state.task.totalCount,
      Person: (state) => state.folder.Person,
      taskStyle: (state) => state.task.taskStyle,
      taskParas: (state) => state.task.taskParas,
      selectTaskList: (state) => state.task.selectTaskList,
    }),
    selectArrId() {
      //选中的ID集合
      return this.$store.state.task.selectTaskList.map((item) => {
        return item.ID;
      });
    },
  },
  methods: {
    headerDragend(newWidth, oldWidth, column, event) {
      setTimeout(() => {
        this.$refs.taskTable.doLayout();
      }, 500);
    },
    getTagName(row) {
      let tagnames = "";
      if (row.TagList != null && row.TagList.length > 0) {
        tagnames = row.TagList.map(
          (tag) =>
            ` <span style="background:${tag.COLOR}" class="taskListTag-span">${tag.TAGNAME}</span>`
        ).join(" ");
      }
      return tagnames;
    },
    getTaskShowName(row) {
      let name = "";
      if (!row.CONTENT) {
        name = row.TASKNAME;
      } else {
        name = row.TASKNAME + "-";
      }
      return name;
    },
    getList() {
      // this.$store.dispatch("changeTaskSource");
    },
    isDisabled(row, index) {
      if (this.isGroup) {
        if (row.TASKTYPE !== "E9354DE41375") {
          return false;
        } else {
          if (this.selectArrId.indexOf(row.ID) < 0) return true;
          else return false;
        }
        return true;
      } else return true;
    },
    editShow(task) {
      this.taskInfo = task;
      let viewType = this.TaskType.filter((item) => item.ID === task.TASKTYPE);
      this.$refs.CreateTask.OpenDialog(viewType[0], 1, this.taskStyle, task);
    },
    createUserName(str) {
      if (str && str.split(" ").length > 0) return str.split(" ")[0];
      return str;
    },
    excuteUserName(str) {
      if (str && str.split(" ").length > 0) return str.split(" ")[0];
      return str;
    },
    clearSelection() {
      this.$refs.taskTable.clearSelection();
    },
    Highlight(row, title, FieldValue) {
      //高亮显示
      if (row.MatchFields) {
        let fieldRow = row.MatchFields.filter((p) => p.Name === title);
        if (fieldRow.length > 0)
          // alert(row.MatchFields.filter(p => p.Name === 'TASKNAME').Value)
          return FormatHtml(fieldRow[0].Value);
        else return FormatHtml(FieldValue);
      } else {
        return FormatHtml(FieldValue);
      }
    },
    grade(val) {
      let taskIndex = this.taskGroupCurrent.indexOf(this.newRow);
      console.log(taskIndex, "taskIndex");
      if (this.num !== val) {
        this.num = val;
      } else {
        this.num--;
        this.$store.state.task.taskGroupCurrent[
          taskIndex
        ].FOCUSDEGREE = this.num;
      }
      console.log(this.num);
      UpdateTaskMemberFocusDegree(
        this.newRow.ID,
        this.$store.state.task.userId,
        val
      ).then((result) => {
        if (result) console.log("UpdateTaskMemberFocusDegree success");
      });
    },
    taskSelected(row) {
      // this.$refs.taskDetail.openDialog(row);
    },
    isPopover(row) {
      if (row.MatchFields) {
        if (row.MatchFields.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    deleteResult(data) {
      if (data) {
        data.forEach((row) => {
          this.$refs.taskTable.toggleRowSelection(row, false);
        });
      } else {
        this.$refs.taskTable.clearSelection();
      }
    },
    load() {
      if (
        this.isInfiniteScroll &&
        this.$store.state.task.taskSource.length < this.totalCount &&
        this.loading == false
      ) {
        this.$store.state.task.pageIndex = this.$store.state.task.pageIndex + 1;
        this.$store.dispatch("changeScrollPageIndex", {
          index: this.$store.state.task.pageIndex,
          type: this.$store.state.task.type,
        });
      }
    },
    guantc() {},

    getTaskType(row) {
      let typelist = this.TaskType.filter((item) => item.ID == row.TASKTYPE);
      if (typelist.length > 0) {
        return [
          {
            iconfont: true,
          },
          row.childrens ? "icon-weibiaoti5" : 'icon-'+typelist[0].ICON, //typelist[0].REMARK
          "tasktype",
        ];
      } else {
        return [
          {
            iconfont: true,
          },
          "icon-renwu5",
          "tasktype",
        ];
      }
    },
    // isDisabled() {
    //   if (this.copyitem) {
    //     return false;
    //   } else {
    //     return false;
    //   }
    // },
    timeFormat(time) {
      // 时间格式化
      return time.substring(0, 19).replace("T", " ");
    },
    changeCurTask(row) {
      if (this.isShowButton) {
        this.$store.commit("changeCurTask", row);
      }
    },
    handleCurrentChange(row) {
      // 选中行数据
      clearTimeout(time); //首先清除计时器
      time = setTimeout(() => {
        if (row) {
          this.newRow = row;
          console.log("单击--row", row);
          this.changeCurTask(row);
          this.$emit("changeCurTask", row);
        }
      }, 300); //大概时间300ms
      this.$refs.taskTable.clearSelection();
      this.$refs.taskTable.toggleRowSelection(row);
    },
    rowDbclick(row, event) {
      clearTimeout(time); //清除
      console.log("row", row);
      // //双击行事件
      //双击行事件
      if (this.taskParas.CreateUserIds == "super" && this.userId != "super") {
      } else if (this.isTemplate) {
        this.editShow(row);
      } else {
        if (row.TASKTYPE == "E9354DE41375") {
          this.$store.commit("changeCurTask", {});
          this.GetSubTaskTreePathByTaskId(row.ID, row);
        } else {
          this.changeCurTask(row);
          this.openBlank(row);
        }
      }
    },
    dbclick(row) {
      //双击行事件
      if (row.TASKTYPE == "E9354DE41375") {
        // this.$store.commit("setTaskGroupCurrents", row.ID);
        this.$store.commit("changeCurTask", {});
        this.GetSubTaskTreePathByTaskId(row.ID, row);
      } else {
        this.changeCurTask(row);
        this.openBlank(row);
      }
    },
    GetSubTaskTreePathByTaskId(taskId, row) {
      GetSubTaskTreePathByTaskId(taskId, this.userId).then((result) => {
        if (result.length > 0) {
          this.$store.commit("setTaskGroupCurrentData", {
            taskGroupCurrent: result,
            row: row,
          });
        } else {
          this.$store.commit("setTaskGroupCurrentData", {
            taskGroupCurrent: [],
            row: row,
          });
        }
      });
    },
    openBlank(row) {
      let pars = {
        TaskId: row.ID,
        Person: this.Person,
      };
      AddTaskViewHistory(pars).then((pmevent) => {});
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: {
          taskid: row.ID,
          tasktype: row.TASKTYPE,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    rowContextmenu(row, column, event) {
      console.log(row);
      if (!this.isTemplate) {
        this.contextmenuRow = row;

        event.preventDefault();
        const postition = {
          top: event.clientY,
          left: event.clientX,
        };
        this.$refs.contextMenu.Show(postition);
      }
    },
    open() {
      this.dbclick(this.contextmenuRow);
    },
    workRecordDetail() {
      this.taskIds = AllChildNode(this.contextmenuRow, "ID");
      this.$refs.workRecordDialog.OpenDialog(this.taskIds);
    },
    handleFolderMenuClick() {
      this.changeCurTask(this.contextmenuRow);
      this.openBlank(this.contextmenuRow);
    },
    drag() {
      const el = document.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      Sortable.create(el, {
        disabled: !this.enableDrag,
        // draggable: ".notAllowed",
        handle: ".notAllowed",
        ghostClass: "sortable-ghost",
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        onEnd: (evt) => {
          alert(evt);
        },
      });
    },
    paste() {
      //粘贴
    },
    save() {
      //保存模板
    },
    copy() {
      //复制
      this.copyitem = this.contextmenuRow;
      // this.$store.commit("setCopy", this.contextmenuRow);
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        group: "shared",
        sort: false,
        disabled: false,
        dropBubble: true,
        dragoverBubble: true,
        onEnd: function () {
          console.log("onEnd");
          _this.$store.commit("setDragId", "");
          _this.$store.commit("draggableRow", {});
        },
        onStart: function ({ newIndex, oldIndex }) {
          const currRow = _this.taskGroupCurrent[oldIndex]; //.splice(oldIndex, 1)[0];
          _this.$store.commit("draggableRow", currRow);
        },
      });
    },
    //列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldItem = this.dropCol[evt.oldIndex];
          this.dropCol.splice(evt.oldIndex, 1);
          this.dropCol.splice(evt.newIndex, 0, oldItem);
        },
      });
    },
    select(selection, row) {
      let aaa = selection.indexOf(row);
      if (aaa > -1) {
        this.$store.commit("addResult", {
          row: row,
          bol: true,
        });
      } else {
        this.$store.commit("addResult", {
          row: row,
          bol: false,
        });
      }
    },
    selectAll(selection) {
      //全选事件
      if (selection.length > 0) {
        this.selectionArr = Object.assign({}, selection);
        selection.forEach((c) => {
          this.$store.commit("addResult", {
            row: c,
            bol: true,
          });
        });
      } else {
        console.log(this.selectionArr, "this.selectionArr");
        Object.keys(this.selectionArr).forEach((key) => {
          this.$store.commit("addResult", {
            row: this.selectionArr[key],
            bol: false,
          });
        });
      }
    },
  },
  mounted() {
    // this.rowDrop();
    this.$store.commit("getTaskGroup", this.taskSource);
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  watch: {
    isCheckbox(val, oldval) {
      setTimeout(() => {
        this.$refs.taskTable.doLayout();
      }, 500);
    },
    taskSource(newItems, oldItems) {
      this.$store.commit("getTaskGroup", newItems);
    },
    GroupCurrent(newData, oldData) {
      if (this.isStore) {
        this.taskGroupCurrent = newData;
      }
    },
    tableData(newData, oldData) {
      if (!this.isStore) {
        this.taskGroupCurrent = newData;
      }
    },
  },
  filters: {
    createSourceFormater: function (val) {
      switch (val) {
        case 0:
          return "PC桌面";
        case 1:
          return "微信";
        case 2:
          return "电话";
        case 3:
          return "网站";
        case 8:
          return "统一桌面";
        case 5:
          return "邮件";
        case 6:
          return "监控";
        case 7:
          return "运维APP";
        default:
          return "";
      }
    },
    taskDegreeFormater: function (val) {
      switch (val) {
        case 0:
          return "重要且紧急";
        case 1:
          return "重要不紧急";
        case 2:
          return "紧急不重要";
        case 3:
          return "不重要不紧急";
        default:
          return "";
      }
    },
    focusDegreeFormater: function (val) {
      switch (val) {
        case 1:
          return "一级关注";
        case 2:
          return "二级关注";
        case 3:
          return "三级关注";
        default:
          return "";
      }
    },
    taskStateFormater: function (val) {
      switch (val) {
        case 0:
          return "daijieshou";
        case 1:
          return "zhixingzhong";
        case 2:
          return "wancheng";
        case 3:
          return "guanbi";
        case 4:
          return "shenpizhong";
        case 5:
          return "guaqizhong";
        case -1:
          return "zuofei";
        default:
          return "guanbi";
      }
    },
  },
};
</script>

<style lang="less">
.taskListTag-span {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  font-size: 16px;
  font-weight: normal;
  line-height: 30px;
  padding: 5px;
  border-radius: 5px;
  color: #fff;
}
</style>
<style lang="less" scoped>
.taskName1 {
  font-weight: bold;
  // color: #34ace9;
  // overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // margin-left: 5px;
}
@keyframes treeTableShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes treeTableShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.sonTaskColor {
  color: #ffb84b;
}

.NameHighLight {
  cursor: pointer;
  color: #46a1ff;
}

.ms-tree-space {
  position: relative;
  top: 1px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: 18px;
  height: 14px;
}

.ms-tree-space::before {
  content: "";
}

.processContainer {
  width: 100%;
  height: 100%;
}

table td {
  line-height: 26px;
}

.tree-ctrl {
  position: relative;
  cursor: pointer;
  color: #2196f3;
  margin-left: -18px;
  margin-right: 5px;
}

.tasktype {
  color: #409eff;
  float: left;
  margin-right: 10px;
}
</style>
<style scoped>
.taskGroupList >>> .el-scrollbar__wrap {
  overflow-x: auto;
}

.daiding {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daiding.png);
}

.daijieshou {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daijieshou.png);
}

.shenpizhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/shenpizhong.png);
}

.wancheng {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/wancheng.png);
}

.zhixingzhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zhixingzhong.png);
}

.zuofei {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zuofei.png);
}

.guanbi {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/guanbi.png);
}

.guanzhu1 {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.guanzhu2 {
  width: 36px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.guanzhu3 {
  width: 54px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.noguanzhu {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/未关注.png);
}
.tag {
  position: sticky;
  display: block;
  right: 0;
  margin-left: 10px;
}
</style>
